export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Product.vue?vue&type=template&id=3dda8e6b"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Product.vue?vue&type=template&id=3dda8e6b
// module id = 75
// module chunks = 0